import gql from 'graphql-tag';

export const ProductPriceOverrides = gql`
    fragment ProductPriceOverrides on CMProduct {
        PriceOverrides {
            edges {
                node {
                    ID # Brand or Branch
                    ... on OfficesBranch {
                        _join {
                            PriceOverride {
                                ID
                                PriceTier
                                BasePrice
                                SellingPrice
                                BrandID
                            }
                        }
                    }
                    ... on OfficesUsername {
                        _join {
                            PriceOverride {
                                ID
                                PriceTier
                                BasePrice
                                SellingPrice
                                BrandID
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const VariationPriceOverrides = gql`
    fragment VariationPriceOverrides on Variation {
        PriceOverrides {
            edges {
                node {
                    ID # Brand or Branch
                    ... on OfficesBranch {
                        _join {
                            PriceOverride {
                                ID
                                PriceTier
                                BasePrice
                                SellingPrice
                                BrandID
                            }
                        }
                    }
                    ... on OfficesUsername {
                        _join {
                            PriceOverride {
                                ID
                                PriceTier
                                BasePrice
                                SellingPrice
                                BrandID
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default gql`
    fragment Product on CMProduct {
        ID
        Created
        LastEdited
        Title
        Content
        BasePrice
        BaseWorth
        Quantity
        GST
        ITC
        LegacyKey
        AllowPurchase
        SellingPrice
        PurchasePrice
        InternalItemID
        XeroCostsCode
        XeroSalesCode
        ImageID
        ImageURL
        Parent {
            ... on ProductCategory {
                ID
                Title
                URLSegment
            }
            ... on CoreProductCategory {
                ID
                Title
                URLSegment
            }
        }
        ProductCategories {
            ... on ProductCategory {
                ID
                Title
                URLSegment
            }
            ... on CoreProductCategory {
                ID
                Title
                URLSegment
            }
        }
        RelatedProducts {
            edges {
                node {
                    ID
                }
            }
        }
        Variations(limit: 999) {
            edges {
                node {
                    ID
                    IsRetired
                    ShortDescription
                    Price
                    Worth
                    SellingPrice
                    PurchasePrice
                    InternalItemID
                    AttributeValues {
                        edges {
                            node {
                                ID
                                Value
                                Type {
                                    ID
                                    Label
                                }
                            }
                        }
                    }
                    ...VariationPriceOverrides
                }
            }
        }
        ...ProductPriceOverrides
    }
    ${ProductPriceOverrides}
    ${VariationPriceOverrides}
`;
